import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { FaArrowUp } from "react-icons/fa";

// export default function ScrollToTopButton() {
  const ScrollToTopButton = () =>{

  const [visible, setVisible] = useState(false);

  useEffect(() => {

    const handleScroll = () => {

      if (window.scrollY > 350) {
        setVisible(true);
      } else {
        setVisible(false);
      }

    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);

  }, []);

  const scrollTop = () => {

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });

  };

  if (!visible) return null;

  return (

    <motion.button
      onClick={scrollTop}

      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}

      className="
      fixed bottom-6 right-6 z-[999]
      w-11 h-11
      rounded-full
      backdrop-blur-md
      bg-white/70
      dark:bg-black/50
      border border-gray-300
      flex items-center justify-center
      shadow-md
      hover:shadow-xl
      transition
      "
    >

      <FaArrowUp className="text-gray-700 text-sm"/>

    </motion.button>
  );
}

export default ScrollToTopButton;